import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

interface IProps {
  id: string;
}

export const useGetKeyHostDetails = ({ id }: IProps): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.GET_KEY_HOST_DETAILS, { id: id }],
    {
      enabled: !!id, // Only run query if id exists
      retry: false, // Don't retry on failure
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      notifyOnChangeProps: [
        "data",
        "error",
        "refetch",
        "isRefetching",
        "isSuccess",
        "isLoading",
      ],
    }
  );
};
